import { createTheme } from '@abyss/web/tools/theme';
import { V2Drawer } from '@abyss/web/ui/Drawer';
import { Markdown } from '@abyss/web/ui/Markdown';
import { ThemeProvider } from '@abyss/web/ui/ThemeProvider';

export const InformationalDrawer = ({
  header,
  content,
  isDrawerOpen,
  setIsDrawerOpen,
}: {
  header: string;
  content: string;
  isDrawerOpen: boolean;
  setIsDrawerOpen: (isOpen: boolean) => void;
}) => {
  const handleOnClose = () => {
    setIsDrawerOpen(false);
  };
  const theme = createTheme('uhc', { enterpriseFont: true });

  return (
    <ThemeProvider theme={theme}>
      <V2Drawer
        data-testid="informational-drawer"
        header={header}
        isOpen={isDrawerOpen}
        onClose={handleOnClose}
        position="right"
        size="$sm"
      >
        <Markdown>{content}</Markdown>
      </V2Drawer>
    </ThemeProvider>
  );
};
